import { api } from "./base";
/**
 * Подписка текущего пользователя. Только для авторизованного аккаунта: гостю
 * и неавторизованному запрос слать нельзя (см. `useMySubscription`).
 */
export const getMySubscription = async () => {
    const response = await api.get("/api/v1/public/subscriptions/me");
    return response.data?.subscription ?? null;
};
/**
 * Отменить подписку: автопродление отключается, доступ сохраняется до
 * `expires_at`. Идемпотентно; возвращает состояние после отмены. Подписки нет —
 * 404 `subscription_not_found`.
 */
export const cancelMySubscription = async () => {
    const response = await api.post("/api/v1/public/subscriptions/cancel");
    return response.data?.subscription ?? null;
};
